export default function IconBallonMessage() {
  return (
    <svg
      id="icon_impedimento"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Caminho_4317"
        data-name="Caminho 4317"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Caminho_4318"
        data-name="Caminho 4318"
        d="M2,8.994A5.99,5.99,0,0,1,8,3h8a6,6,0,0,1,6,5.994V21H8a6,6,0,0,1-6-5.994ZM20,19V8.994A4,4,0,0,0,16,5H8A3.99,3.99,0,0,0,4,8.994v6.012A4,4,0,0,0,8,19Zm-6-8h2v2H14ZM8,11h2v2H8Z"
        fill="#8b8f8f"
      />
    </svg>
  );
}
